<template>
  <div class="status" :class="status">
    <icon :name="icons[status]" /> {{ $t(labels[status]) }}
  </div>
</template>

<script>
export default {
  name: "TemplateStatus",
  props: ["status"],
  data: function () {
    return {
      icons: {
        success: "check-square",
        pending: "spinner",
        error: "exclamation-triangle",
        toBeCreated: "exclamation-triangle",
        deleted: "exclamation-triangle",
      },
      labels: {
        success: "label_selfAssessment_saveStatus_saved",
        pending: "label_selfAssessment_saveStatus_saving",
        error: "label_selfAssessment_saveStatus_error",
        toBeCreated: "label_selfAssessment_saveStatus_toBeCreated",
        deleted: "label_selfAssessment_saveStatus_deleted",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
/* components/template/_template-status.vue */
.status {
  width: 100%;
  text-align: right;
  .fa-icon {
    position: relative;
  }
  &.success {
    color: #2bae63;
    svg {
      fill: #2bae63;
    }
  }
  &.pending {
    color: #ffc107;
    svg {
      fill: #ffc107;
    }
  }
  &.error {
    color: red;
    svg {
      fill: red;
    }
  }
}
</style>
